module.exports = __webpack_public_path__ + "static/media/background-principal.ba0868b9.png";